
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, NgZone } from '@angular/core';
 import { MatDialog } from '@angular/material';
 import { Router } from '@angular/router';
 import { DataTableDirective } from 'angular-datatables';
 import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
 import { Subject } from 'rxjs';
 import { BackendApiService } from 'src/app/service/backendapi.service';
 import { DataSharingService } from 'src/app/service/data-sharing.service';
 import { EndpointsService } from 'src/app/service/endpoints.service';
 import * as XLSX from 'xlsx'
 import { ExportToCsv } from 'export-to-csv';

@Component({
  selector: 'app-community-table-data',
  templateUrl: './community-table-data.component.html',
  styleUrls: ['./community-table-data.component.scss']
})
export class CommunityTableDataComponent implements OnInit {

   @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
   dtOptions: any = {};
   dataToBeDownloaded: any = [];
   dtTrigger: Subject<any> = new Subject();
   @Input() tableData: any;
   @Input() urlLastPart: any;
   @Output() refreshTableData = new EventEmitter();
   title:any='Community';
   fileName:any;
   expandedRows: { [key: number]: boolean } = {};
 
 
   constructor(private dialog: MatDialog,private dataSharingService: DataSharingService,private spinnerService: Ng4LoadingSpinnerService,
     private endpointsService: EndpointsService,private router: Router,private ngZone: NgZone,
     private backendApiService: BackendApiService) { }
 
   ngOnInit(): void {
 
     for(var i=0; i<=this.tableData.length-1 ; i++)
     {
       this.dataToBeDownloaded.push({
         'Community Name': this.tableData[i].communityName ,
         'Free Roam Validity': this.tableData[i].freeRoamValidity ,
         'Message Interval': this.tableData[i].messageInterval, 
         'Stay Home Interval': this.tableData[i].stayHomeInterval,
         'Counter Stay HOme Interval': this.tableData[i].counterStayHomeInterval ,
         'Rates Applied': this.tableData[i].ratesApplied ,
         MOC: this.tableData[i].moc, 
         MTC: this.tableData[i].mtc, 
         SMSMO: this.tableData[i].smsmo, 
         GPRS: this.tableData[i].grps, 
         'Data Others': this.tableData[i].dataOthers, 
         'Vpmn Country': this.tableData[i].vpmnCountry,
        'VPMN Network': this.tableData[i].vpmnNetwork, });
       
     }
     console.log("tabledatatat",this.tableData)
     
     console.log("this.dataToBeDownloaded",this.dataToBeDownloaded)
 
 
     console.log("urlLastPart", this.urlLastPart)
     this.dtOptions = {
       paging: true,
       pagingType: 'full_numbers',
       scroller: true,
       scrollCollapse: true,
       scrollX: true,
       responsive: true,
       select: true,
       dom: '<\'row\'<\'col-sm-12 col-md-3\'l><\'col-sm-12 col-md-3\'B><\'col-sm-12 col-md-6\'f>>' +
         '<\'row\'<\'col-sm-12\'tr>>' +
         '<\'row\'<\'col-sm-12 col-md-3 entries\'i><\'col-sm-12 col-md-9 entries\'p>>',
        buttons: [
           {
             text: 'CSV',
           action: () => {
             
             this.downloadcsv(this.dataToBeDownloaded , this.title);
             this.storeAnalytics();
           }
         },
           {
             text: 'EXCEL',
             action: () => {
               
               this.exportTable(this.title);
               this.storeAnalytics();
             },
           }
         ],
       // columnDefs: [{
       //   targets: [11], // column or columns numbers
       //   orderable: false  // set orderable for selected columns
       // }]
     };
   }
   public downloadcsv(serviceSummaryData, title) {
     console.log('serviceSummaryData ', serviceSummaryData);
     var data1 = document.getElementById('view-table');
     const options = {
       filename: title,
       fieldSeparator: ',',
       quoteStrings: '"',
       decimalSeparator: '.',
       useTextFile: false,
       useBom: true,
       useKeysAsHeaders: true,
       // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
     };
     const csvExporter = new ExportToCsv(options);
     csvExporter.generateCsv(serviceSummaryData);
   }
   
   exportTable(title) {
     const workSheet = XLSX.utils.json_to_sheet(this.dataToBeDownloaded);
     const workBook: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
     XLSX.writeFile(workBook, title+'.xlsx');
 }

   toggleExpand(index: number): void {
  this.expandedRows[index] = !this.expandedRows[index];
}



getLimitedList(value: string, index: number): string {
  if (!value) return '';
  
  const items = value.split(',');
  const isExpanded = this.expandedRows[index];

  if (isExpanded || items.length <= 3) {
    return items.join(', ');
  } else {
    return items.slice(0, 3).join(', ') + '...';
  }
}
 
   ngOnDestroy(): void {
     this.dtTrigger.unsubscribe();
   }
 
   rerender(): void {
     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
       // Destroy the table first
       dtInstance.destroy();
       // Call the dtTrigger to rerender again
       this.dtTrigger.next();
     });
   }
 
   ngAfterViewInit(): void {
     this.dtTrigger.next();
   }
 
   downloadAllData()
   {
     let apiUrl = this.endpointsService.URL_DOWNLOAD_SMS_PDP_DATA + this.urlLastPart ;
     
     window.open(apiUrl);
     this.storeAnalytics1();
 
     // this.backendApiService.callToApi(apiUrl).subscribe(response => {
     //   if (response === null)
     //     return;
 
     
     // });
     this.spinnerService.hide();
 
   }
   storeAnalytics() {
     const apiUrl1 = this.endpointsService.CENTRY_LOG +
         'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=SMS PDP' + '&module=community' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
       this.backendApiService.callToApi(apiUrl1).subscribe(response => {
        console.log(response);
       });
   
     }
   storeAnalytics1() {
     const apiUrl1 = this.endpointsService.CENTRY_LOG +
         'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=SMS PDP' + '&module=community' + '&operation=download_report' + '&opname=is_report_downloaded' + '&opvalue=true';
       this.backendApiService.callToApi(apiUrl1).subscribe(response => {
        console.log(response);
       });
   
     }
 }
 